module.exports = __webpack_public_path__ + "1793882494189/images/north-america.ac4661b.png";